var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardLeftCrashIconNormal = function SvgNewcsDashboardLeftCrashIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_left_crash_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M431 384h20v20h-20z",
    "data-name": "\\u77E9\\u5F62 293"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_left_crash_icon_normal_svg__a)",
    transform: "translate(-431 -384)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M433 403a2 2 0 0 1-2-2v-14a2 2 0 0 1 1.33-1.884h.013a2 2 0 0 1 .557-.116H449a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2Zm-.5-2a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-10h-17Zm0-14v2.5h17V387a.5.5 0 0 0-.5-.5h-16.054a.5.5 0 0 0-.392.27v.007a.5.5 0 0 0-.054.223Zm8.322 10.225-3.092 3.092-1.061-1.06 3.092-3.092-3.092-3.092 1.061-1.06 3.092 3.092 3.092-3.092 1.06 1.06-3.092 3.092 3.092 3.092-1.06 1.06ZM437 388a1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1Zm-3 0a1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1Z",
    "data-name": "\\u8054\\u5408 24"
  }))));
};
export default SvgNewcsDashboardLeftCrashIconNormal;